/* eslint-disable import/prefer-default-export */

import { GRID } from "../../../constants";

const { PRICING_METHODS } = GRID;
const {
  BUNDLE_PRICING,
  DIY_PRICING,
  FLAT_PRICE,
  PERCENTAGE_OF_TOTAL,
  STEP_TIER_PRICING,
  TIER_PRICING,
  VOLUME_PRICING,
} = PRICING_METHODS;

// Custom JSON manipulator for screen 3
export const manipulateCustomJSONThree = (
  customJSON,
  isEdit,
  formRowData,
  fieldMapIndex,
  pricingMethodData,
) => {
  const tempJSON = [...customJSON];

  /**
   * change "Quantity Editable" - "qty_editable"
   */
  const qtyEditableIndex = tempJSON.findIndex(
    item => item.name === "qty_editable",
  );
  const tempQtyEditableObj = { ...tempJSON[qtyEditableIndex] };
  if (
    [
      BUNDLE_PRICING,
      STEP_TIER_PRICING,
      TIER_PRICING,
      VOLUME_PRICING,
      PERCENTAGE_OF_TOTAL,
    ].includes(pricingMethodData.view) ||
    ((pricingMethodData.view === FLAT_PRICE ||
      pricingMethodData.view === DIY_PRICING) &&
      (formRowData[fieldMapIndex.quantity_uom] === "" ||
        !Object.prototype.hasOwnProperty.call(
          formRowData,
          fieldMapIndex.quantity_uom,
        )))
  ) {
    tempQtyEditableObj.disabled = true;
  } else {
    tempQtyEditableObj.disabled = false;
  }
  tempJSON[qtyEditableIndex] = tempQtyEditableObj;

  /**
   * change "Selling Term Editable" - "sellingterm_editable"
   */
  const sellingtermEditableIndex = tempJSON.findIndex(
    item => item.name === "sellingterm_editable",
  );
  const tempSellingtermEditableIndexObj = {
    ...tempJSON[sellingtermEditableIndex],
  };
  if (
    formRowData[fieldMapIndex.recurring_period] === "" ||
    [PERCENTAGE_OF_TOTAL].includes(pricingMethodData.view)
  ) {
    tempSellingtermEditableIndexObj.disabled = true;
  } else {
    tempSellingtermEditableIndexObj.disabled = false;
  }
  tempJSON[sellingtermEditableIndex] = tempSellingtermEditableIndexObj;

  /**
   * change "SKU Quantity Editable" - "sku_quantity_editable"
   */
  const skuQtyEditableIndex = tempJSON.findIndex(
    item => item.name === "sku_quantity_editable",
  );
  const tempSkuQtyEditableObj = { ...tempJSON[skuQtyEditableIndex] };
  if ([PERCENTAGE_OF_TOTAL].includes(pricingMethodData.view)) {
    tempSkuQtyEditableObj.disabled = true;
  } else {
    tempSkuQtyEditableObj.disabled = false;
  }
  tempJSON[skuQtyEditableIndex] = tempSkuQtyEditableObj;

  return tempJSON;
};
